var map = {
	"./artificial-intelligence.png": "9578",
	"./coding.png": "97e2",
	"./contact-us.svg": "7539",
	"./data-storage.png": "4c5c",
	"./developer.svg": "f0c5",
	"./digital-marketting.png": "85d2",
	"./flag-ca.png": "542a",
	"./flag-np.png": "e06d",
	"./flag-tnt.png": "60b0",
	"./logo.png": "c5f3",
	"./media-placeholder.png": "c28d",
	"./mobile-app.png": "dcd7",
	"./slider6-2000x1334-96.jpg": "7a6c",
	"./user.png": "baf4",
	"./web-app.png": "8b79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "38fc";